(function() {
    'use strict';

    angular.module('JetBov.auth', [
            'JetBov.auth.login',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('auth', {
                url: '/auth',
                template: '<div ui-view autoscroll="true" autoscroll-body-top></div>',
                abstract: true
            });
    }

})();
(function() {
    'use strict';

    angular.module('JetBov.filters', [
        'JetBov.filters.zpad'
    ]);
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages', [
        'ui.router',
        'JetBov.pages.dashboard',
        'JetBov.pages.orders',
        'JetBov.pages.config',
        'JetBov.pages.tagLot',
        'JetBov.pages.animals',
        'JetBov.pages.tags',
        'JetBov.pages.producers',
        'JetBov.pages.appointments'
    ])
        .config(stateConfig)
        .config(routeConfig);

    /** @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('app', {
                url: '/app',
                templateUrl: 'app/pages/pages.html',
                abstract: true,
                data: {
                    permissions: {
                        only: ['AUTHORIZED_USER',],
                        redirectTo: 'auth.login'
                    }
                }
            });
    }

    /** @ngInject */
    function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
        // $urlRouterProvider.otherwise('/dashboard');
        $urlRouterProvider.otherwise(function ($injector) {
            var $state = $injector.get("$state");
            $state.go('app.dashboard');
        });
    }
})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function() {
    'use strict';

    angular.module('JetBov.auth.login', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('auth.login', {
                url: '/login',
                templateUrl: 'app/auth/login/login.html',
                controller: 'loginController'
            });
    }

})();
angular.module('JetBov.filters.zpad', []).filter('zpad', function() {
    return function(input, n) {
        if (input === undefined)
            input = "";
        if (input.length >= n)
            return input;
        var zeros = "0".repeat(n);
        return (zeros + input).slice(-1 * n);
    };
});
(function () {
    'use strict';

    angular.module('JetBov.pages.animals', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.animals', {
                url: '/animals',
                templateUrl: 'app/pages/animals/animals.html',
                title: 'Animais',
                sidebarMeta: {
                    order: 5,
                    icon: 'ion-ios-pricetags',
                },
                controller: 'animalsController'
            });
    }

})();
(function () {
    'use strict';

    angular.module('JetBov.pages.config', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.config', {
                url: '/config',
                title: 'Configurações',
                template: '<div ui-view autoscroll="true" autoscroll-body-top></div>',
                sidebarMeta: {
                    icon: 'ion-ios-gear',
                    order: 9999,
                },
            })
            .state('app.config.activities', {
                url: '/activities',
                templateUrl: 'app/pages/config/activities/activities.html',
                title: 'Atividades',
                sidebarMeta: {
                    icon: 'ion-android-list',
                    order: 7,
                },
                controller: 'activitiesController'
            })
            .state('app.config.sequence', {
                url: '/sequence',
                templateUrl: 'app/pages/config/sequence/sequence.html',
                title: 'Sequencias',
                sidebarMeta: {
                    order: 9999,
                    icon: 'fa fa-table',
                },
                controller: 'sequenceController'
            }).state('app.config.appointments', {
                url: '/appointments',
                templateUrl: 'app/pages/config/appointments/appointments.html',
                title: 'Projetos',
                sidebarMeta: {
                    order: 6,
                    icon: 'fa fa-table',
                },
                controller: 'appointmentsController'
            });
    }

})();
(function () {
    'use strict';

    angular.module('JetBov.pages.appointments', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.appointments', {
                url: '/appointments',
                templateUrl: 'app/pages/appointments/appointments.html',
                title: 'Apontamentos',
                sidebarMeta: {
                    order: 6,
                    icon: 'fa fa-hand-o-right',
                },
                controller: 'appointmentsProducerController'
            });
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('JetBov.pages.dashboard', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.dashboard', {
                url: '/dashboard',
                templateUrl: 'app/pages/dashboard/dashboard.html',
                title: 'Painel de Gestão',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
                controller: 'dashboardController'
            });
    }

})();
(function() {
    'use strict';

    angular.module('JetBov.pages.orders', ['ui.select'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.orders', {
                url: '/orders',
                templateUrl: 'app/pages/orders/orders.html',
                title: 'Pedidos',
                sidebarMeta: {
                    order: 100,
                    icon: 'ion-ios-cart'
                },
                controller: 'ordersController'
            });
    }

})();
(function () {
    'use strict';

    angular.module('JetBov.pages.producers', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.producers', {
                url: '/producers',
                templateUrl: 'app/pages/producers/producers.html',
                title: 'Produtores',
                sidebarMeta: {
                    order: 5,
                    icon: 'ion-ios-person',
                },
                controller: 'producersController'
            });
    }

})();
(function() {
    'use strict';

    angular.module('JetBov.pages.tagLot', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.tagLot', {
                url: '/tagLot?page=1&page_size=20',
                templateUrl: 'app/pages/tagLot/tagLot.html',
                title: 'Lotes de Brincos',
                sidebarMeta: {
                    order: 0,
                    icon: 'ion-ios-list',
                },
                controller: 'tagLotController'
            });
    }

})();

(function() {
    'use strict';

    angular.module('JetBov.pages.tags', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('app.tags', {
                url: '/tags',
                templateUrl: 'app/pages/tags/tags.html',
                title: 'Brincos',
                sidebarMeta: {
                    order: 1,
                    icon: 'ion-ios-pricetags',
                },
                controller: 'tagsController'
            });
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

// (function () {
//     'use strict';

//     angular.module('JetBov.pages.activities', [])
//         .config(routeConfig);

//     /** @ngInject */
//     function routeConfig($stateProvider) {
//       $stateProvider
//         //   .state('app.activities', {
//         //     url: '/activities',
//         //     templateUrl: 'app/pages/activities/activities.html',
//         //     title: 'Atividades',
//         //     sidebarMeta: {
//         //         icon: 'ion-android-list',
//         //         order: 7,
//         //     },
//         //     controller:'activitiesController'
//         //   });
//     }

//   })();
// (function () {
//     'use strict';

//     angular.module('JetBov.pages.appointments', [])
//         .config(routeConfig);

//     /** @ngInject */
//     function routeConfig($stateProvider) {
//         $stateProvider
//             .state('app.appointments', {
//                 url: '/appointments',
//                 templateUrl: 'app/pages/appointments/appointments.html',
//                 title: 'Apontamentos',
//                 sidebarMeta: {
//                     order: 6,
//                     icon: 'fa fa-hand-o-right',
//                     },
//                 controller: 'appointmentsController'
//             });
//     }

//   })();
(function() {
    'use strict';

    angular.module('BlurAdmin', [
            'ngAnimate',
            'ngResource',
            'ui.bootstrap',
            'ui.sortable',
            'ui.router',
            'permission',
            'permission.ui',
            'ngTouch',
            'ngCookies',
            'toastr',
            'smart-table',
            "xeditable",
            'ui.slimscroll',
            'ngJsTree',
            'FileSaver',
            'angular-progress-button-styles',
            'BlurAdmin.theme',
            'BlurAdmin.pages',
            'JetBov.auth',
            'JetBov.filters',
        ])
        .run(permissionsConfig)
        .run(roleConfig)
        .run(forceSSL)
        .config(resourceProviderConfig)
        .config(configHttpInterceptor)
        .directive("filesInput", function() {
            return {
              require: "ngModel",
              link: function postLink(scope,elem,attrs,ngModel) {
                elem.on("change", function(e) {
                  var files = elem[0].files;
                  ngModel.$setViewValue(files);
                })
              }
            }
          });

    /** @ngInject */
    function permissionsConfig(PermPermissionStore, LoginService) {
        PermPermissionStore
            .definePermission('userLoggedIn', /*@ngInject*/ function() {
                return LoginService.loggedIn();
            });
        PermPermissionStore
            .definePermission('cooperativeUser', /*@ngInject*/ function() {
                return LoginService.isCooperativeUser();
            });

    }

    /** @ngInject */
    function roleConfig(PermRoleStore, $cookieStore, LoginService) {
        PermRoleStore.defineRole('AUTHORIZED_USER', ['userLoggedIn', 'cooperativeUser']);
    }

    /** @ngInject */
    function resourceProviderConfig($resourceProvider) {
        // Don't strip trailing slashes from calculated URLs
        $resourceProvider.defaults.stripTrailingSlashes = false;
    }

    /** @ngInject */
    function configHttpInterceptor() {

    }
    /** @ngInject */
    function forceSSL($location, $window) {
        if ($location.protocol() !== 'https') {
            console.log("Need to Redirect");
        }
        if (location.hostname === 'cooperativas.jetbov.com')
            if ($location.protocol() !== 'https') {
                // $window.location.href = $location.absUrl().replace('http', 'https');
                window.location.href = $location.absUrl().replace('http', 'https');
            } else {
                console.log("Fake Redirect SSL");
            }
        else
            console.log("Ok Then... let's go...");
    }
})();
(function() {
    'use strict';
    angular
        .module('BlurAdmin')
        .constant("resources", {
            "User": {
                "endpoint": "user"
            },
            "Users": {
                "endpoint": "users"
            },
            "Profile": {
                "endpoint": "profile"
            },
            "Order": {
                "endpoint": "tags/order"
            },
            "Sequence": {
                "endpoint": "tags/sequence"
            },
            "Tag": {
                "endpoint": "tags/tag"
            },
            "TagLot": {
                "endpoint": "tags/tagLot"
            },
            "AllFarms": {
                "endpoint": "allfarms"
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('BlurAdmin')
        .factory('JetBovApi', JetBovApi)
        .factory('serverAddress', serverAddress);

    /** ngInject */
    function JetBovApi($resource, resources) {
        var apiObject = {};
        for (var resourceName in resources) {
            if (resources.hasOwnProperty(resourceName)) {
                var resourceEndpoint = resources[resourceName].endpoint;
                apiObject[resourceName] = $resource(serverAddress() + resourceEndpoint + '/:id/',
                    // Creates a PUT method defined as 'update'
                    {
                        id: '@id',
                    }, {
                        update: {
                            method: 'PUT',
                            params: { id: '@id' }
                        },
                        query: {
                            method: 'GET',
                            isArray: true
                        },
                        get: {
                            method: 'GET',
                        },
                        save: {
                            method: 'POST',
                        },
                        delete: {
                            method: 'DELETE',
                            params: { id: '@id' },
                        }
                    }
                );
            }
        }
        return apiObject;
    }

    function serverAddress() {
        var serverAddress = location.protocol + "//localhost:8000/api/";
        if (location.hostname == "cooperativas.jetbov.com") {
            serverAddress = location.protocol + "//api.jetbov.com/api/";
        } else {
            if (location.hostname == "cooper-delta.jetbov.com") {
                serverAddress = "http://api-delta.jetbov.com/api/";
            }
        }
        return serverAddress;
    }
})();

(function() {
    'use strict';

    angular
        .module('BlurAdmin')
        .service('LoginService', LoginService);

    /** @ngInject */
    function LoginService($cookieStore, $http, $rootScope, JetBovApi) {
        this.loggedIn = loggedIn;
        this.isCooperativeUser = isCooperativeUser;

        function loggedIn() {
            if ($cookieStore.get('jbtoken')) {
                $http.defaults.headers.common.Authorization = 'Token ' + $cookieStore.get('jbtoken');
                JetBovApi.User.get({}, function(data) {
                    $rootScope.user = data;
                    $rootScope.is_coop_user = data.is_cooperative_user;
                });
                return true;
            } else {
                return false;
            }
        }

        function isCooperativeUser() {
            // if (loggedIn()) {
            //     JetBovApi.User.get({}, function(data) {
            //         return data.is_cooperative_user;
            //     });
            // }
            return true;
        }
    }
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
    'use strict';

    angular
        .module('JetBov.auth.login')
        .controller('loginController', loginController);

    /** @ngInject */
    function loginController($scope, $state, $http, $cookieStore, $rootScope, serverAddress, JetBovApi, LoginService) {

        if (LoginService.loggedIn()) {
            $state.go('app.tagLot');
        }

        $scope.login = function() {
            var user_data = {
                "username": $scope.email,
                "password": $scope.password,
            };

            if (user_data.username !== "" && user_data.password !== "") {
                $http.post(serverAddress + "api-token-auth/", user_data)
                    .success(function(response) {
                        if (response.non_field_errors) {
                            alertLogin('Não foi possível validar seu usuário. Verifique seu usuário e sua senha e tente novamente.');
                        } else {
                            $cookieStore.put('jbtoken', response.token);
                            $http.defaults.headers.common.Authorization = 'Token ' + response.token;

                            // if (mixpanelConfig.enabled && $scope.email.indexOf('jetbov.com') == -1) {
                            //     $mixpanel.identify($scope.email);
                            //     $mixpanel.people.set({
                            //         "Last Login on": new Date()
                            //     });

                            //     $mixpanel.track('User Login', {
                            //         email: $scope.account.email
                            //     });
                            // }

                            // $rootScope.user = {};
                            // $rootScope.user.account = $scope.email;
                            // $rootScope.user.email = $scope.email;

                            JetBovApi.User.get({}, function(data) {
                                $rootScope.user = data;
                                $rootScope.is_coop_user = data.is_cooperative_user;
                                $state.go('app.tagLot');
                            });
                        }
                    })
                    .catch(function(response) {
                        // TODO: Translation
                        alertLogin('Não foi possível validar seu usuário. Verifique seu usuário e sua senha e tente novamente.');
                    });
            } else {
                alertLogin('Por favor, informe os dados de acesso para validar sua conta.');
            }
        };

        function alertLogin(msg) {
            swal({
                // title: ,
                text: msg,
                type: 'error',
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('JetBov.pages.animals')
        .controller('animalsController', animalsController);

    /** @ngInject */
    function animalsController($rootScope, $scope, $http, $filter, JetBovApi, $uibModal, serverAddress, $log) {
        $scope.itemsPerPage = 20;
        $scope.currentPage = 1;
        var tagSearchChanged = false;

        $scope.filter = {
            'gt': '',
            'lt': '',
            'status': { label: 'Todos animais', value: '' }
        };

        $scope.statusItems = [
            { label: 'Todos animais', value: '' },
            { label: 'na fazenda', value: 'live' },
            { label: 'Abatidos', value: 'sold' },
            { label: 'Perdido', value: 'lost' },
            { label: 'Morto', value: 'dead' }
        ];

        $scope.updateData = function (filter) {
            $scope.isLoading = true;
            var currentPage = $scope.currentPage || 1;
            if (tagSearchChanged) {
                currentPage = 1;
                $scope.currentPage = currentPage;
                tagSearchChanged = false;
            }

            var url = serverAddress + 'tags/animals/?ordering=tag_number&page_size=' + $scope.itemsPerPage + '&page=' + currentPage;
            if (filter && filter.search) {
                url += '&search=' + filter.search;
            }
            if (filter && filter.gt) {
                url += '&gt=' + filter.gt;
            }
            if (filter && filter.lt) {
                url += '&lt=' + filter.lt;
            }
            if (filter && filter.status) {
                url += '&status=' + filter.status.value;
            }
            $http.get(url).then(function (response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalItems = data.count;
                    $scope.tagData = data.results;
                    $scope.isLoading = false;
                }
            });

        }

        function countMonths(startDate, endDate) {
            var stepDate = new Date;
            stepDate.time = startDate.time;
            var monthCount = 0;

            while (stepDate.time <= endDate.time) {
                stepDate.month += 1;
                monthCount += 1;
            }

            if (stepDate != endDate) {
                monthCount -= 1;
            }

            return monthCount;
        }

        function monthDiff(d1, d2) {
            var months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth() + 1;
            months += d2.getMonth();
            // edit: increment months if d2 comes later in its month than d1 in its month
            if (d2.getDate() >= d1.getDate())
                months++
            // end edit
            return months <= 0 ? 0 : months;
        }

        $scope.calculateAge = function calculateAge(birthday) { // birthday is a date
            var birthday = new Date(birthday)
            // var ageDifMs = Date.now() - birthday.getTime();
            // var ageDate = new Date(ageDifMs); // miliseconds from epoch
            // var age = (ageDate.getUTCFullYear() - 1970) * 12;
            return monthDiff(birthday, new Date()) + ' meses';

        }

        $scope.pageChanged = function (pageNumber, pageSize, filter) {
            $log.log('Page changed to: ' + pageNumber);
            $scope.currentPage = pageNumber;
            $scope.itemsPerPage = pageSize;
            $scope.updateData(filter);
        };

        $scope.updateData();
    }
})();
(function () {
    'use strict';

    angular
        .module('JetBov.pages.appointments')
        .controller('appointmentsProducerController', appointmentsProducerController);

    /** @ngInject */
    function appointmentsProducerController($rootScope, $scope, $http, $filter, JetBovApi, $uibModal, serverAddress, $log) {
        $scope.itemsPerPageApp = 20;
        $scope.currentAppPage = 1;

        $scope.updateAppointmentData = function (filter) {
            $scope.isLoading = true;
            var currentPage = $scope.currentAppPage || 1;

            var url = serverAddress + 'tags/appointments_registry/?ordering=name&page_size=' + $scope.itemsPerPageApp + '&page=' + currentPage;
            if (filter && filter.search) {
                url += '&search=' + filter.search;
            }

            $http.get(url).then(function (response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalAppItems = data.count;
                    $scope.producersApp = data.results;
                    $scope.isLoading = false;
                }
            });
        }


        $scope.appoint = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/producers/producersModal/producersModal.html',
                controller: 'producersModalController',
                size: 'lg',
                resolve: {
                    producerId: function () {
                        return null;
                    },
                    item: function () {
                        return null;
                    }
                }
            }).result.then(function (res) {
                $scope.updateAppointmentData();
            })
        }

        $scope.edit = function (item) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/producers/producersModal/producersModal.html',
                controller: 'producersModalController',
                size: 'lg',
                resolve: {
                    producerId: function () {
                        return null;
                    },
                    item: function () {
                        return item;
                    }
                }
            }).result.then(function (res) {
                $scope.updateAppointmentData();
            })
        }



        $scope.delete = function (appointment) {
            swal({
                title: 'Excluir Apontamento',
                text: 'Deseja excluir este Apontamento?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'EXCLUIR',
                cancelButtonText: 'FECHAR',
                allowOutsideClick: false
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $http.delete(serverAddress + "tags/appointments_registry/" + appointment.id + "/").success(function (response) {
                        swal({
                            title: 'Apontamento de Produtor',
                            text: 'Apontamento excluido com sucesso.',
                            type: 'success'
                        })
                        $scope.appointment = {}
                        var pos = $scope.producersApp.indexOf(appointment)
                        if (pos != -1) {
                            $scope.producersApp.splice(pos, 1)
                        }
                    })
                        .catch(function (error) {
                            // TODO: Translation
                            swal({
                                title: 'Apontamento de Produtor',
                                text: 'Não foi possível excluir o Apontamento: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                }
            });

        }

        $scope.updateAppointmentData()

        $scope.pageChangedApp = function (pageNumber, pageSize, filter) {
            $log.log('Page changed to: ' + pageNumber);
            $scope.currentAppPage = pageNumber;
            $scope.itemsPerPageApp = pageSize;
            $scope.updateAppointmentData(filter);
        };

        $scope.updateAppointmentData = function (filter) {
            $scope.isLoading = true;
            var currentPage = $scope.currentAppPage || 1;

            var url = serverAddress + 'tags/appointments_registry/?ordering=name&page_size=' + $scope.itemsPerPageApp + '&page=' + currentPage;
            if (filter && filter.search) {
                url += '&search=' + filter.search;
            }

            $http.get(url).then(function (response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalAppItems = data.count;
                    $scope.producersApp = data.results;
                    $scope.isLoading = false;
                }
            });

        }
        $scope.listAttachments = function (arr, title) {
          $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/producers/attachmentsModal/attachmentsModal.html',
              controller: 'attachmentsModalController',
              size: 'md',
              resolve: {
                  item: function () {
                      return arr;
                  },
                  title: function () {
                      return title;
                  }
              }
          })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('JetBov.pages.dashboard')
        .controller('dashboardController', dashboardController);

    /** @ngInject */
    function dashboardController($scope, $rootScope, $filter, editableOptions, editableThemes, JetBovApi) {

    }
})();
(function() {
    'use strict';

    angular
        .module('JetBov.pages.orders')
        .controller('ordersController', ordersController);

    /** @ngInject */
    function ordersController($rootScope, $scope, $http, JetBovApi, $uibModal, serverAddress) {
        $scope.smartTablePageSize = 10;

        $rootScope.$on('order-updated', function(event) {
            JetBovApi.Order.query(function(data) {
                $scope.orderData = data;
            });
        });

        $scope.newOrder = function() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/orders/orderModal/orderModal.html',
                controller: 'orderModalController',
                size: 'lg',
                resolve: {
                    editing: function() {
                        return false;
                    },
                    order: function() {
                        return {};
                    }
                }
            }).result.then(function(order) {
                JetBovApi.Order.save(order, function() {
                    $rootScope.$broadcast('order-updated');
                });
            }, function() {
                // dismissed
            });
        };

        $scope.editOrder = function(order_id, operation) {
            JetBovApi.Order.get({ id: order_id }, function(data) {
                var order = data;
                if (operation === 'delete') {
                    swal({
                        title: 'Excluir Pedido?',
                        text: 'Deseja excluir este pedido?',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'EXCLUIR',
                        cancelButtonText: 'FECHAR',
                        allowOutsideClick: false
                    }).then(function(isConfirm) {
                        if (isConfirm) {
                            order.deleted = true;
                            JetBovApi.Order.update(order, function() {
                                swal({
                                    title: 'Excluir Pedido',
                                    text: 'Exclusão concluída',
                                    type: 'success'
                                });
                                $rootScope.$broadcast('order-updated');
                            }, function(error) {
                                swal({
                                    title: 'Pedidos de Brinco',
                                    text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                                    type: 'error'
                                });
                            });
                        }
                    });
                } else {
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/orders/orderModal/orderModal.html',
                        controller: 'orderModalController',
                        size: 'lg',
                        resolve: {
                            editing: function() {
                                return true;
                            },
                            order: function() {
                                return order;
                            }
                        }
                    }).result.then(function(edited_order) {
                        JetBovApi.Order.update(edited_order, function() {
                            $rootScope.$broadcast('order-updated');
                        }, function(error) {
                            swal({
                                title: 'Pedidos de Brinco',
                                text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                    }, function() {
                        // dismissed
                    });
                }
            }, function(error) {
                swal({
                    title: 'Pedidos de Brinco',
                    text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            });
        };

        $scope.sendOrder = function(order_id) {
            JetBovApi.Order.get({ id: order_id }, function(data) {
                var order = data;
                swal({
                    title: "Pedidos de Brincos",
                    text: "Confirma que este pedido foi enviado para o fornecedor?",
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: "CONFIRMAR",
                    cancelButtonText: "FECHAR",
                    allowOutsideClick: false
                }).then(function(isConfirm) {
                    if (isConfirm) {
                        order.sent = true;
                        order.sent_on = (new Date()).toJSON();
                        JetBovApi.Order.update(order, function() {
                            swal({
                                title: 'Pedidos de Brinco',
                                text: 'Pedido marcado como enviado.',
                                type: 'success'
                            }).then(function() {
                                $rootScope.$broadcast('order-updated');
                            });
                        }, function(error) {
                            swal({
                                title: 'Pedidos de Brinco',
                                text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                    }
                });
            }, function(error) {
                swal({
                    title: 'Pedidos de Brinco',
                    text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            });
        };

        $scope.receiveOrder = function(order_id) {
            swal({
                title: "Pedidos de Brincos",
                text: "Confirma que este pedido foi recebido do fornecedor?",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: "CONFIRMAR",
                cancelButtonText: "FECHAR",
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: function(email) {
                    return $http.post(serverAddress + "tags/order/set_received/", { order_id: order_id });
                }
            }).then(function(response) {
                swal({
                    title: 'Pedidos de Brinco',
                    text: 'Pedido marcado como recebido.',
                    type: 'success'
                }).then(function() {
                    $rootScope.$broadcast('order-updated');
                });
            }, function(error) {
                swal({
                    title: 'Pedidos de Brinco',
                    text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            });
        };

        $rootScope.$broadcast('order-updated');
    }



})();
(function () {
    'use strict';

    angular
        .module('JetBov.pages.producers')
        .controller('producersController', producersController);

    /** @ngInject */
    function producersController($rootScope, $scope, $http, $filter, JetBovApi, $uibModal, serverAddress, $log) {
        $scope.itemsPerPage = 20;
        $scope.currentPage = 1;
        $scope.itemsPerPageApp = 20;
        $scope.currentAppPage = 1;
        $scope.producers = []
        $scope.producer = {}
        $scope.filter = {
            'name': ''
        };

        $scope.filterApp = {
            'name': ''
        };

        $scope.updateData = function (filter) {
            $scope.isLoading = true;
            var currentPage = $scope.currentPage || 1;

            var url = serverAddress + 'tags/producers/?ordering=name&page_size=' + $scope.itemsPerPage + '&page=' + currentPage;
            if (filter && filter.search) {
                url += '&search=' + filter.search;
            }

            $http.get(url).then(function (response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalItems = data.count;
                    $scope.producers = data.results;
                    $scope.isLoading = false;
                }
            });

        }

        $scope.pageChanged = function (pageNumber, pageSize, filter) {
            $log.log('Page changed to: ' + pageNumber);
            $scope.currentPage = pageNumber;
            $scope.itemsPerPage = pageSize;
            $scope.updateData(filter);
        };


        $scope.updateData();

        $scope.save = function (producer) {
            if (producer.id) {
                $http.put(serverAddress + "tags/producers/" + producer.id + "/", producer)
                    .success(function (response) {
                        swal({
                            title: 'Produtores',
                            text: 'Produtor atualizado com sucesso.',
                            type: 'success'
                        })
                        $scope.producer = {}
                        producer = {}
                    })
                    .catch(function (error) {
                        // TODO: Translation
                        swal({
                            title: 'Produtores',
                            text: 'Não foi possível atualizar o produtor: (' + error.statusText + ' ' + error.data + ')',
                            type: 'error'
                        });

                    });
            }
            else {
                $http.post(serverAddress + "tags/producers/", producer)
                    .success(function (response) {
                        swal({
                            title: 'Produtores',
                            text: 'Produtor criado com sucesso.',
                            type: 'success'
                        })
                        $scope.producers.push(response)
                        $scope.producer = {}
                        producer = {}
                    })
                    .catch(function (error) {
                        // TODO: Translation
                        swal({
                            title: 'Produtores',
                            text: 'Não foi possível criar o produtor: (' + error.statusText + ' ' + error.data + ')',
                            type: 'error'
                        });

                    });
            }
        }

        $scope.edit = function (item) {
            $scope.producer = item
        }

        $scope.appoint = function (producer) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/producers/producersModal/producersModal.html',
                controller: 'producersModalController',
                size: 'lg',
                resolve: {
                    producerId: function () {
                        return producer.id;
                    },
                    item: function () {
                        return null;
                    }
                }
            })
        }

        $scope.delete = function (producer) {
            swal({
                title: 'Excluir Produtor',
                text: 'Deseja excluir este produtor?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'EXCLUIR',
                cancelButtonText: 'FECHAR',
                allowOutsideClick: false
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $http.delete(serverAddress + "tags/producers/" + producer.id + "/").success(function (response) {
                        swal({
                            title: 'Produtores',
                            text: 'Produtor excluido com sucesso.',
                            type: 'success'
                        })
                        $scope.producer = {}
                        var pos = $scope.producers.indexOf(producer)
                        if (pos != -1) {
                            $scope.producers.splice(pos, 1)
                        }
                    })
                        .catch(function (error) {
                            // TODO: Translation
                            swal({
                                title: 'Produtores',
                                text: 'Não foi possível excluir o produtor: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                }
            });
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('JetBov.pages.tagLot')
        .controller('tagLotController', tagLotController);

    /** @ngInject */
    function tagLotController($rootScope, $scope, $http, JetBovApi, $uibModal, serverAddress, FileSaver, $log) {
        $scope.tagLotDataSize = 25;
        $scope.itemsPerPage = 20;
        $scope.currentPage = 1;
        $scope.farmName = null;
        $scope.forceFirstPage = false;

        $rootScope.$on('taglot-updated', function(event) {
            updateData();
        });

        $rootScope.$broadcast('taglot-updated');

        $scope.pageChanged = function(pageNumber, pageSize, farm_name_search) {
            $log.log('Page changed to: ' + pageNumber);
            $scope.currentPage = pageNumber;
            $scope.itemsPerPage = pageSize;
            $scope.farmName = farm_name_search
            updateData($scope.farmName);
        };

        $scope.filterByFarmName = function(farm_name){
            if($scope.farmName != farm_name){
                $scope.forceFirstPage = true;
            }
            $scope.farmName = farm_name;
            updateData();
        }

        $scope.newTagLot = function() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/tagLot/tagLotModal/tagLotModal.html',
                controller: 'tagLotModalController',
                size: 'lg',
                resolve: {
                    editing: function() {
                        return false;
                    },
                    tagLotConfig: function() {
                        return {};
                    }
                }
            }).result.then(function(tagLotConfig) {
                    // console.log(tagLotConfig);
                    $http.post(serverAddress + "tags/lot/create_lot/", tagLotConfig)
                        .success(function(response) {
                            swal({
                                title: 'Lote de Brinco',
                                text: 'Lote separado com sucesso.',
                                type: 'success'
                            }).then(function() {
                                $rootScope.$broadcast('taglot-updated');
                            });
                        })
                        .catch(function(error) {
                            // TODO: Translation
                            swal({
                                title: 'Pedidos de Brinco',
                                text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });

                        });

                    // JetBovApi.TagLot.save(tagLotConfig, function() {
                    //     swal({
                    //         title: 'Lotes de Brinco',
                    //         text: 'Lote cadastrado com sucesso!!!',
                    //         type: 'success'
                    //     }).then(function() {
                    //         $rootScope.$broadcast('taglot-updated');
                    //     });
                    // }, function(error) {
                    //     swal({
                    //         title: 'Lotes de Brinco',
                    //         text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                    //         type: 'error'
                    //     });
                    // });
                },
                function() {
                    // dismissed
                }
            );
        };

        $scope.deleteLot = function(tagLotId) {
            JetBovApi.TagLot.get({ id: tagLotId }, function(data) {
                var taglot = data;
                swal({
                    title: 'Excluir Lote?',
                    text: 'Deseja excluir este Lote?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'EXCLUIR',
                    cancelButtonText: 'FECHAR',
                    allowOutsideClick: false
                }).then(function(isConfirm) {
                    if (isConfirm) {
                        taglot.deleted = true;
                        JetBovApi.TagLot.update(taglot, function() {
                            swal({
                                title: 'Excluir Lote',
                                text: 'Exclusão concluída',
                                type: 'success'
                            });
                            $rootScope.$broadcast('taglot-updated');
                        }, function(error) {
                            swal({
                                title: 'Lotes de Brinco',
                                text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                    }
                });
            }, function(error) {
                swal({
                    title: 'Lotes de Brinco',
                    text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            });
        };

        $scope.cancelDeliverLot = function(tagLotId) {
            JetBovApi.TagLot.get({ id: tagLotId }, function(data) {
                var taglot = data;
                swal({
                    title: 'Estorno de Entrega',
                    text: 'Tem certeza que deseja estornar esta entrega de lote? ',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não estornar',
                    allowOutsideClick: false
                }).then(function(result) {
                    if (result) {
                        $http.get(serverAddress + "tags/tagLot/" + taglot.id + "/canceldelivery/")
                        .success(function (response) {
                            swal({
                                title: 'Lotes de Brinco',
                                text: 'Estorno concluído',
                                type: 'success'
                            });
                            $rootScope.$broadcast('taglot-updated');
                        }).catch(function (error) {
                            swal({
                                title: 'Lotes de Brinco',
                                text: 'Não foi possível fazer esta operação: (' + error.data.message + ')',
                                type: 'error'
                            });
                        });
                    }
                });
            }, function(error) {
                swal({
                    title: 'Lotes de Brinco',
                    text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            });
        }

        $scope.deliverLot = function(tagLotId) {
            JetBovApi.TagLot.get({ id: tagLotId }, function(data) {
                var taglot = data;
                swal({
                    title: 'Lotes de Brinco',
                    text: 'Para quem o lote de brincos foi entregue?',
                    input: 'text',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'ENTREGAR',
                    cancelButtonText: 'FECHAR',
                    allowOutsideClick: false
                }).then(function(result) {
                    if (result) {
                        taglot.delivered = true;
                        taglot.delivered_on = new Date();
                        taglot.delivered_to = result;
                        JetBovApi.TagLot.update(taglot, function() {
                            swal({
                                title: 'Lotes de Brinco',
                                text: 'Entrega concluída',
                                type: 'success'
                            });
                            $rootScope.$broadcast('taglot-updated');
                        }, function(error) {
                            swal({
                                title: 'Lotes de Brinco',
                                text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                    }
                });
            }, function(error) {
                swal({
                    title: 'Lotes de Brinco',
                    text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            });
        };
        $scope.excelLot = function(tagLotId, usedCount) {
            var excludeUsedTags = false;
            var url = serverAddress + "tags/lot/" + tagLotId + "/export/";
            if (usedCount > 0) {
                swal({
                    title: 'Lotes de Brinco',
                    text: 'Existem brincos usados neste lote, ',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'COM BRINCOS USADOS',
                    cancelButtonText: 'SEM BRINCOS USADOS',
                    allowOutsideClick: false
                }).then(function(result) {
                    if (result) {
                        getExcelTagLog(url + '?withUsedTags=true');
                    }
                }, function(dismiss) {
                    getExcelTagLog(url);
                });
            } else {
                getExcelTagLog(url);
            }
        };

        function getExcelTagLog(url) {
            $http.get(url, { responseType: "arraybuffer" })
                .success(function(response) {
                    var blobData = new Blob([response]);
                    FileSaver(blobData, 'Planilha de Entrada.xlsx');
                    swal({
                        title: 'Lote de Brinco',
                        text: 'Planilha de Entrada de Animais Emitida.',
                        type: 'success'
                    });
                })
                .catch(function(error) {
                    // TODO: Translation
                    swal({
                        title: 'Pedidos de Brinco',
                        text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                        type: 'error'
                    });

                });
        }

        $scope.excelLotReceipt = function(tagLotId) {
            $http.get(serverAddress + "tags/lot/" + tagLotId + "/receipt/", { responseType: "arraybuffer" })
                .success(function(response) {
                    var blobData = new Blob([response]);
                    FileSaver(blobData, 'Recibo de Brincos.xls');
                    swal({
                        title: 'Lote de Brinco',
                        text: 'Planilha de Recibo para Financeiro Emitida.',
                        type: 'success'
                    });
                })
                .catch(function(error) {
                    // TODO: Translation
                    swal({
                        title: 'Pedidos de Brinco',
                        text: 'Não foi possível fazer esta operação: (' + error.statusText + ' ' + error.data + ')',
                        type: 'error'
                    });

                });
        };

        function updateData() {
            $scope.isLoading = true;

            var currentPage = 1;
            if($scope.forceFirstPage){
                currentPage = 1
                $scope.forceFirstPage = false;
            }else{
                currentPage = $scope.currentPage || 1
            }

            var search_term = ($scope.farmName != undefined && $scope.farmName) != '' ? ('&search=' + $scope.farmName) : '';

            var list_ordering = '&ordering=-delivered_on';

            var url = serverAddress + 'tags/tagLot/?page_size=' + $scope.itemsPerPage + '&page=' + currentPage + search_term + list_ordering;

            $http.get(url).then(function(response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalItems = data.count;
                    $scope.tagLotData = data.results;
                    $scope.isLoading = false;
                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('JetBov.pages.tags')
        .controller('tagsController', tagsController);

    /** @ngInject */
    function tagsController($rootScope, $scope, $http, $filter, JetBovApi, $uibModal, serverAddress, $log) {
        $scope.itemsPerPage = 20;
        $scope.currentPage = 1;
        var tagSearchChanged = false;

        function updateData() {
            $scope.isLoading = true;
            var currentPage = $scope.currentPage || 1;
            if (tagSearchChanged) {
                currentPage = 1;
                $scope.currentPage = currentPage;
                tagSearchChanged = false;
            }
            var url = serverAddress + 'tags/tag/?ordering=tag_number&page_size=' + $scope.itemsPerPage + '&page=' + currentPage;
            if ($scope.tagNumber) {
                url = serverAddress + 'tags/tag/?ordering=tag_number&page_size=' + $scope.itemsPerPage + '&page=' + currentPage + '&search=' + $scope.tagNumber;
            }
            $http.get(url).then(function(response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalItems = data.count;
                    $scope.tagData = data.results;
                    $scope.isLoading = false;
                }
            });

            // JetBovApi.Tag.query(function(data) {
            //     $scope.tagData = data;
            //     $scope.isLoading = false;
            // });
        }

        $scope.pageChanged = function(pageNumber, pageSize) {
            $log.log('Page changed to: ' + pageNumber);
            $scope.currentPage = pageNumber;
            $scope.itemsPerPage = pageSize;
            updateData();
        };

        $scope.filterByTagNumber = function(tagNumber) {
            $scope.tagNumber = tagNumber;
            tagSearchChanged = true;
            $log.log('Tag Number changed to: ' + tagNumber + '(' + $scope.tagNumber + ')');
            updateData();
        };

        updateData();
    }
})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular
        .module('JetBov.pages.config')
        .controller('activitiesController', activitiesController);

    /** @ngInject */
    function activitiesController($rootScope, $scope, $http, JetBovApi, $uibModal, serverAddress) {
        // $scope.smartTablePageSize = 10;
        $scope.itemsPerPage = 20;
        $scope.currentPage = 1;
        $scope.activities = [];
        $scope.activity = {}
        var searchChanged = false;

        $scope.test = function () {
            if ($scope.appointmentsList != {}) {
                $scope.appointmentsList.apo_id = $scope.appointmentsList.selected
            }
        }

        function listAllActivities() {
            $scope.isLoading = true;
            var currentPage = $scope.currentPage || 1;
            if (searchChanged) {
                currentPage = 1;
                $scope.currentPage = currentPage;
                searchChanged = false;
            }

            // Listar os apontamentos e os ids para ficarem na lista
            var url_appointments = serverAddress + 'tags/appointments/'
            $http.get(url_appointments).then(function (response) {
                if (response.status == 200) {
                    $scope.appointmentsList = {
                        data: response.data.results,
                        selected: {}
                    }
                }
            })

            var url = serverAddress + 'tags/activities/?ordering=title&page_size=' + $scope.itemsPerPage + '&page=' + currentPage;
            if ($scope.searchTitle) {
                url += '&search=' + $scope.searchTitle;
            }

            $http.get(url).then(function (response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalItems = data.count;
                    $scope.activitiesData = data.results;
                    $scope.isLoading = false;
                }
            })
        }

        $scope.save = function () {
            var url = serverAddress + 'tags/activities/';
            if($scope.activity.id){
                var activity = {
                    cooperative: $scope.activity.coop,
                    appointment: $scope.appointmentsList.selected,
                    title: $scope.appointmentsList.apo_act
                };
                $http.put(url+$scope.activity.id+'/', activity)
                    .success(function (response) {
                        swal({
                            title: 'Atividades',
                            text: 'Atividade atualizada com sucesso.',
                            type: 'success'
                        })
                        $scope.activity = {}
                    })
                    .catch(function (error) {
                        swal({
                            title: 'Atividades',
                            text: 'Não foi possível atualizar Atividade: (' + error.statusText + ' ' + error.data + ')',
                            type: 'error'
                        });
                    }).then(function () {
                        listAllActivities();
                    })

            }else{
                var activity = {
                    appointment: $scope.appointmentsList.apo_id,
                    title: $scope.appointmentsList.apo_act
                };
                $http.post(url, activity)
                    .success(function (response) {
                        swal({
                            title: 'Atividades',
                            text: 'Atividade criada com sucesso.',
                            type: 'success'
                        })
                        $scope.activity = {}
                    })
                    .catch(function (error) {
                        swal({
                            title: 'Atividades',
                            text: 'Não foi possível criar Atividade: (' + error.statusText + ' ' + error.data + ')',
                            type: 'error'
                        });
                    }).then(function () {
                        listAllActivities();
                    })
            }
        };

        $scope.edit = function (item) {
            $scope.activity.id = item.id
            $scope.activity.coop = item.cooperative
            $scope.appointmentsList.apo_act = item.title
            $scope.appointmentsList.selected = item.appointment
        }

        $scope.reset = function (item) {
            $scope.activity = {}
        }

        $scope.delete = function (activity) {
            swal({
                title: 'Excluir Atividade',
                text: 'Deseja excluir esta Atividade?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'EXCLUIR',
                cancelButtonText: 'FECHAR',
                allowOutsideClick: false
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $http.delete(serverAddress + "tags/activities/" + activity.pk + "/").success(function (response) {
                        swal({
                            title: 'Atividades',
                            text: 'Atividade excluida com sucesso.',
                            type: 'success'
                        })
                        listAllActivities();
                    })
                        .catch(function (error) {
                            swal({
                                title: 'Produtores',
                                text: 'Não foi possível excluir a atividade: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                }
            });
            listAllActivities();
        }

        $scope.pageChanged = function (pageNumber, pageSize) {
            $log.log('Page changed to: ' + pageNumber);
            $scope.currentPage = pageNumber;
            $scope.itemsPerPage = pageSize;
            listAllActivities();
        };

        $scope.filterByTitle = function (searchTitle) {
            $scope.searchTitle = searchTitle;
            searchChanged = true;
            // $log.log('Tag Number changed to: ' + tagNumber + '(' + $scope.tagNumber + ')');
            listAllActivities();
        };
        listAllActivities();
    }

})();
(function () {
    'use strict';

    angular
        .module('JetBov.pages.config')
        .controller('appointmentsController', appointmentsController);

    /** @ngInject */
    function appointmentsController($rootScope, $scope, $http, $filter, JetBovApi, $uibModal, serverAddress, $log) {
        $scope.itemsPerPage = 20;
        $scope.currentPage = 1;
        $scope.appointments = []
        $scope.filter = {
            'title': ''
        };
        $scope.appointment = {}

        $scope.newAppointment = function (appointment) {
            if (appointment.id) {
                $http.put(serverAddress + "tags/appointments/" + appointment.id + "/", appointment)
                    .success(function (response) {
                        swal({
                            title: 'Projetos',
                            text: 'Projeto atualizado com sucesso.',
                            type: 'success'
                        })
                        $scope.appointment = {}
                    })
                    .catch(function (error) {
                        // TODO: Translation
                        swal({
                            title: 'Projetos',
                            text: 'Não foi possível atualizar o Projeto: (' + error.statusText + ' ' + error.data + ')',
                            type: 'error'
                        });

                    });
            }
            else {
                $http.post(serverAddress + "tags/appointments/", appointment)
                    .success(function (response) {
                        swal({
                            title: 'Projeto',
                            text: 'Projeto criado com sucesso.',
                            type: 'success'
                        })
                        $scope.appointments.push(response)
                        $scope.appointment = {}
                    })
                    .catch(function (error) {
                        // TODO: Translation
                        swal({
                            title: 'Projeto',
                            text: 'Não foi possível criar o Projeto: (' + error.statusText + ' ' + error.data + ')',
                            type: 'error'
                        });

                    });
            }
        }

        $scope.edit = function (item) {
            $scope.appointment = item
        }

        $scope.reset = function (item) {
            $scope.appointment = {}
        }

        $scope.deleteAppointment = function (appointment) {
            swal({
                title: 'Excluir Projeto',
                text: 'Deseja excluir este Projeto? Excluindo este Projeto irá EXCLUIR TODOS AS ATIVIDADES RELACIONADAS',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'EXCLUIR',
                cancelButtonText: 'FECHAR',
                allowOutsideClick: false
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $http.delete(serverAddress + "tags/appointments/" + appointment.id + "/").success(function (response) {
                        swal({
                            title: 'Projeto',
                            text: 'Projeto excluido com sucesso.',
                            type: 'success'
                        })
                        $scope.appointment = {}
                        var pos = $scope.appointments.indexOf(appointment)
                        if (pos != -1) {
                            $scope.appointments.splice(pos, 1)
                        }
                    })
                        .catch(function (error) {
                            // TODO: Translation
                            swal({
                                title: 'Projeto',
                                text: 'Não foi possível excluir o Projeto: (' + error.statusText + ' ' + error.data + ')',
                                type: 'error'
                            });
                        });
                }
            });
        }

        $scope.updateData = function (filter) {
            $scope.isLoading = true;
            var currentPage = $scope.currentPage || 1;

            var url = serverAddress + 'tags/appointments/?ordering=name&page_size=' + $scope.itemsPerPage + '&page=' + currentPage;
            if (filter && filter.search) {
                url += '&search=' + filter.search;
            }

            $http.get(url).then(function (response) {
                if (response.status == 200) {
                    var data = response.data;
                    $scope.totalItems = data.count;
                    $scope.appointments = data.results;
                    $scope.isLoading = false;
                }
            });

        }

        $scope.pageChanged = function (pageNumber, pageSize, filter) {
            $log.log('Page changed to: ' + pageNumber);
            $scope.currentPage = pageNumber;
            $scope.itemsPerPage = pageSize;
            $scope.updateData(filter);
        };

        $scope.updateData();
    }
})();
(function() {
    'use strict';

    angular
        .module('JetBov.pages.config')
        .controller('sequenceController', sequenceController);

    /** @ngInject */
    function sequenceController($scope, $rootScope, $filter, $uibModal, JetBovApi) {
        $scope.smartTablePageSize = 10;

        $rootScope.$on('sequence-updated', function(event) {
            JetBovApi.Sequence.query(function(data) {
                $scope.sequenceData = data;
            });
        });

        $scope.zpad = function(number, last_number) {
            var input = number.toString();
            var n = last_number.toString().length;
            if (input === undefined)
                input = "";
            if (input.length >= n)
                return input;
            var zeros = "0".repeat(n);
            return (zeros + input).slice(-1 * n);
        };

        $scope.newSequence = function() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/config/sequence/sequenceModal/sequenceModal.html',
                controller: 'sequenceModalController',
                size: 'lg',
                resolve: {
                    editing: function() {
                        return false;
                    },
                    sequence: function() {
                        return {};
                    }
                }
            }).result.then(function(sequence) {
                JetBovApi.Sequence.save(sequence, function() {
                    $rootScope.$broadcast('sequence-updated');
                });
            }, function() {
                // dismissed
            });
        };

        $scope.editSequence = function(sequence_id, operation) {
            JetBovApi.Sequence.get({ id: sequence_id }, function(data) {
                var sequence = data;
                if (operation === 'delete') {
                    swal({
                        title: 'Excluir Sequencia?',
                        text: 'Deseja excluir esta sequencia?',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'EXCLUIR',
                        cancelButtonText: 'FECHAR',
                        allowOutsideClick: false
                    }).then(function(isConfirm) {
                        if (isConfirm) {
                            JetBovApi.Sequence.delete(sequence, function() {
                                swal({
                                    title: 'Excluir Sequencia',
                                    text: 'Exclusão concluída',
                                    type: 'success'
                                });
                                $rootScope.$broadcast('sequence-updated');
                            });
                        }
                    });
                } else {
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/config/sequence/sequenceModal/sequenceModal.html',
                        controller: 'sequenceModalController',
                        size: 'lg',
                        resolve: {
                            editing: function() {
                                return true;
                            },
                            sequence: function() {
                                return sequence;
                            }
                        }
                    }).result.then(function(edited_sequence) {
                        JetBovApi.Sequence.update(edited_sequence, function() {
                            $rootScope.$broadcast('sequence-updated');
                        });
                    }, function() {
                        // dismissed
                    });
                }
            });
        };

        $rootScope.$broadcast('sequence-updated');
    }

})();
(function() {
    'use strict';

    angular
        .module('JetBov.pages.config')
        .controller('orderModalController', orderModalController);

    /** @ngInject */
    function orderModalController($scope, $rootScope, $filter, $uibModalInstance, editing, order, JetBovApi) {
        $scope.order = order;
        $scope.sequenceData = [];
        $scope.saveOrder = function() {
            $uibModalInstance.close($scope.order);
        };

        $scope.sequenceChanged = function($item, $model) {
            $scope.order.first_tag = ($item.last_tag_emitted) ? $item.last_tag_emitted + 1 : $item.first_number;
        };

        JetBovApi.Sequence.query(function(data) {
            $scope.sequenceData = data;
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('JetBov.pages.tagLot')
        .controller('attachmentsModalController', attachmentsModalController);

    /** @ngInject */
    function attachmentsModalController($scope, $rootScope, $uibModalInstance, item, title) {
        $scope.attachments = item;
        $scope.title = title;
    }
})();

(function () {
    'use strict';

    angular
        .module('JetBov.pages.tagLot')
        .controller('producersModalController', producersModalController);

    /** @ngInject */
    function producersModalController($scope, $rootScope, $filter, $uibModalInstance, $http, serverAddress, producerId, item) {
        $scope.itemEdit = item;
        $scope.loading = false;
        $scope.attachments = [];
        $scope.currentAttachment = null;

        if ($scope.itemEdit == null) { // if NOT editing item
            $scope.prodAppointment = {};
            $scope.todayDate = new Date();
            $scope.prodAppointment.date = $scope.todayDate;
        } else {
            //else , get all activities and set values to edit
            $http.get(serverAddress + 'tags/activities/').then(function (response) {
                $scope.activityData = response.data.results;
                $scope.prodAppointment = {
                    id: $scope.itemEdit.id,
                    producer_id: $scope.itemEdit.producer,
                    appointment_id: $scope.itemEdit.appointment,
                    appointment: $scope.itemEdit.appointment,
                    cooperative: $scope.itemEdit.cooperative,
                    activity_id: $scope.itemEdit.activity,
                    activity: $scope.itemEdit.activity,
                    description: $scope.itemEdit.description,
                    date: $scope.itemEdit.date ? new Date($scope.itemEdit.date) : new Date(),
                    nextAppointmentDate: $scope.itemEdit.nextAppointmentDate ? new Date($scope.itemEdit.nextAppointmentDate) : undefined,
                    accomplished: $scope.itemEdit.accomplished,
                    cost: parseFloat($scope.itemEdit.cost),
                    // attachment: $scope.itemEdit.filename ? $scope.itemEdit.filename : '',
                    attachments:$scope.itemEdit.attachments
                }
            }, function (error) {
                console.log(error);
            })
        }

        if (producerId != null && $scope.itemEdit == null) { // id producerId is already set and not editing entry
            $scope.prodAppointment.producer_id = producerId;
        } else {
            $http.get(serverAddress + 'tags/producers/?ordering=name&page_size=1000&page=1').then(function (response) {
                $scope.producerData = response.data.results;
            }, function (error) {
                console.log(error)
            })

        }

        $http.get(serverAddress + 'tags/appointments/').then(function (response) { //retrieving appointments
            $scope.appointmentData = response.data.results;
        }, function (error) {
            console.log(error);
        })

        $scope.updateFile = function () { //upate file from editing entry
            swal({
                title: 'Excluir arquivo anexado',
                text: 'Deseja excluir arquivo anexado ao apontamento? ESTA OPERAÇÃO É DEFINITIVA',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'EXCLUIR ARQUIVO',
                cancelButtonText: 'FECHAR',
                allowOutsideClick: false
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $scope.$apply(function () {
                        $scope.prodAppointment.attachment = '';
                    });
                }
            });
        }


        $scope.save = function () {
            $scope.loading = true;
            var formData = new FormData();

            if ($scope.attachments) {
                angular.forEach($scope.attachments, function(attachment){
                    formData.append('file', attachment[0])
                })
            }

            angular.forEach($scope.prodAppointment, function (value, key) {
                console.log(key);
                if (key == 'date' || key == 'nextAppointmentDate') {
                    formData.append(key, value.toISOString().split('T')[0]);
                }
                else {
                    formData.append(key, value);
                }
            });

            $http({
                method: 'POST',
                url: serverAddress + 'tags/appointments_registry/',
                data: formData,
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).success(function (response) {
                $scope.loading = false;
                swal({
                    title: 'Apontamento de Produtor',
                    text: 'Apontamento de podutor criado com sucesso.',
                    type: 'success'
                });
                $uibModalInstance.close();
            }).catch(function (error) {
                console.log(error)
                $scope.loading = false;
                swal({
                    title: 'Apontamento de Produtor',
                    text: 'Não foi possível apontar o produtor: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            })
        };

        $scope.edit = function (item) {
            $scope.loading = true;
            var formData = new FormData();

            if ($scope.attachments) {
                angular.forEach($scope.attachments, function(attachment){
                    formData.append('file', attachment[0])
                })
            }

            angular.forEach($scope.prodAppointment, function (value, key) {
                if (key == 'date' || key == 'nextAppointmentDate') {
                    formData.append(key, value.toISOString());//.split('T')[0]);
                }
                else {
                    formData.append(key, value);
                }
            });

            $http.put(serverAddress + 'tags/appointments_registry/' + $scope.prodAppointment.id + '/', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).success(function (response) {
                $scope.loading = false;
                swal({
                    title: 'Apontamento de Produtor',
                    text: 'Apontamento de podutor atualizado com sucesso.',
                    type: 'success'
                });
                $uibModalInstance.close();
            }).catch(function (error) {
                console.log(error)
                $scope.loading = false;
                swal({
                    title: 'Apontamento de Produtor',
                    text: 'Não foi possível atualizar o apontamento: (' + error.statusText + ' ' + error.data + ')',
                    type: 'error'
                });
            })
        };

        $scope.appointmentSelect = function () {
            $http.get(serverAddress + 'tags/activities/').then(function (response) {
                $scope.activityData = response.data.results;
                $scope.prodAppointment.activity_id = '';
            }, function (error) {
                console.log(error);
            })
        }

        $scope.activitySelect = function () {
            if ($scope.itemEdit) {
                $scope.prodAppointment.activity = $scope.prodAppointment.activity_id;
            }
        }

        $scope.addAttachment =  function () {
            // console.log('--', $scope.currentAttachment);
            if ($scope.currentAttachment){
                $scope.attachments.push($scope.currentAttachment);
                $scope.currentAttachment = null;
            }
        }

        $scope.removeFile = function (file){
            var pos = $scope.attachments.indexOf(file)
            if (pos != -1) {
                $scope.attachments.splice(pos, 1)
            }
        }

        $scope.removeAttachment =  function (att) {
            swal({
                title: 'Excluir Anexo!',
                text: 'Deseja excluir o anexo ' + att.filename + ' ? \n Esta ação não pode ser desfeita!',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'EXCLUIR',
                cancelButtonText: 'FECHAR',
                allowOutsideClick: false
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $http.delete(serverAddress + "tags/attachments/" + att.id + "/").success(function (response) {
                        swal({
                            title: 'Anexo.',
                            text: 'Anexo excluído com sucesso.',
                            type: 'success'
                        })
                        // $scope.appointment = {}
                        var pos = $scope.itemEdit.attachments.indexOf(att)
                        if (pos != -1) {
                            $scope.itemEdit.attachments.splice(pos, 1)
                        }
                    }).catch(function (error) {
                          // TODO: Translation
                          swal({
                              title: 'Anexo.',
                              text: 'Não foi possível excluir o anexo: (' + error.statusText + ' ' + error.data + ')',
                              type: 'error'
                          });
                    });
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('JetBov.pages.tagLot')
        .controller('tagLotModalController', tagLotModalController);

    /** @ngInject */
    function tagLotModalController($scope, $rootScope, $filter, $uibModalInstance, $http, editing, tagLotConfig, JetBovApi, serverAddress) {
        $scope.tagLotConfig = tagLotConfig;
        $scope.sequenceData = [];
        $scope.saveTagLotConfig = function() {
            $uibModalInstance.close($scope.tagLotConfig);
        };

        $scope.sequenceChanged = function($item, $model) {
            $http.get(serverAddress + 'tags/sequence/' + $item.id + "/first_available_tag/").then(function(response) {
                if (response.status === 200)
                    $scope.tagLotConfig.first_tag = response.data;
                else
                    swal({
                        type: 'error',
                        title: 'Erro no Servidor',
                        text: 'Os servidores do JetBov estão tendo um problema. (' + response.data + ')'
                    }).then(function() {
                        $uibModalInstance.$dismss();
                    });
            });
        };

        JetBovApi.Sequence.query(function(data) {
            $scope.sequenceData = data;
        });

        JetBovApi.AllFarms.query(function(data) {
            $scope.farmData = data;
        });
    }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService) {

        $scope.menuItems = baSidebarService.getMenuItems();
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

        $scope.hoverItem = function($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function() {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function() {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = function($state, layoutSizes) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function() {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function(item) {
                        return item.level == 0;
                    });

                    menuItems.forEach(function(item) {
                        var children = states.filter(function(child) {
                            return child.level == 1 && child.name.indexOf(item.name) === 0;
                        });
                        item.subMenu = children.length ? children : null;
                    });

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function(isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function() {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function() {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function(item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function(s) {
                            return s.sidebarMeta && !s.abstract;
                        })
                        .map(function(s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length - 1,
                                // level: meta.level,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name,
                            };
                        })
                        .sort(function(a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };

    }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: ['$scope','$cookieStore','$state',function ($scope,$cookieStore,$state) {

        $scope.signOut = function () {
          swal({
            title:'Sair do JetBov Cooperativas',
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'SAIR',
            cancelButtonText: 'NÃO',
            allowOutsideClick: false
          }).then(function (isConfirm) {
            if (isConfirm) {
              $cookieStore.remove('jbtoken');
              $state.go('auth.login');
            }
          });
        };
      }]
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.inputs')
        .directive('baSwitcher', baSwitcher);

    /** @ngInject */
    function baSwitcher() {
        return {
            templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
            scope: {
                switcherStyle: '@',
                switcherValue: '=',
                textOn: '@',
                textOff: '@',
                ngChange: '='
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('JetBov.pages.config')
        .controller('sequenceModalController', sequenceModalController);

    /** @ngInject */
    function sequenceModalController($scope, $filter, $uibModalInstance, editing, sequence) {
        $scope.sequence = sequence;
        $scope.saveSequence = function() {
            $uibModalInstance.close($scope.sequence);
        };
    }
})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/pages.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-right">Created with <i class="ion-heart"></i></div><div class="al-footer-main clearfix"><div class="al-copy">JetBov para Cooperativas 2017</div></div></footer><back-top></back-top></main>');
$templateCache.put('app/auth/login/login.html','<main class="auth-main"><div class="auth-block"><h1>Entrar no <span class="al-logo"><span>JetBov</span>Cooperativas</span></h1><form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email" ng-model="email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Senha</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Senha" ng-model="password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth" ng-click="login()">Entrar</button> <a href="" class="forgot-pass">Esqueceu a senha?</a></div></div></form></div></main>');
$templateCache.put('app/pages/animals/animals.html','<div ba-panel=""><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><div><div class="col-md-6"><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="updateData()"><i class="fa fa-search"></i></span> <input type="text" name="sarch" id="search" class="form-control" value="" placeholder="Busca por fazenda ou brinco" ng-model="filter.search" ng-change="updateData(filter)"></div></div><div class="col-md-2"><ui-select ng-model="filter.status" ng-change="updateData(filter)" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Situa\xE7\xE3o"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in statusItems"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="col-md-2"><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="updateData()">maior que</span> <input type="number" class="form-control" value="" ng-model="filter.gt" ng-change="updateData(filter)"> <span class="input-group-addon addon-right input-group-addon" ng-click="updateData()">meses</span></div></div><div class="col-md-2"><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="updateData()">menor que</span> <input type="number" width="20" class="form-control" value="" ng-model="filter.lt" ng-change="updateData(filter)"> <span class="input-group-addon addon-right input-group-addon" ng-click="updateData()">meses</span></div></div></div><table class="table table-striped" st-pipe="callServer" st-table="tagDataDisplay" st-safe-src="tagData"><thead><tr class="sortable"><th st-sort="farm" st-sort-default="true">Fazenda</th><th st-sort="tagNumber">Brinco</th><th>Situa\xE7\xE3o</th><th st-sort="birthday">DT Nasc</th><th st-sort="idade">Idade</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in tagDataDisplay"><td>{{item.farm_name}}</td><td>{{(item.sold) ? item.tagNumberHistory : item.tagNumber}}</td><td>{{(item.sold) ? "Abatido " : (item.lost) ? "Perdido " : (item.dead) ? "Morto " : "na fazenda "}}</td><td>{{item.birthday | date:"dd/MM/yyyy "}}</td><td>{{ calculateAge(item.birthday)}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></td></tr></tbody><tfoot><tr><td colspan="2"><ul uib-pagination="" total-items="totalItems" ng-model="currentPage" items-per-page="itemsPerPage" max-size="10" ng-change="pageChanged(currentPage, itemsPerPage, filter)" class="pagination-sm" boundary-link-numbers="true" rotate="false"></ul></td><td></td><td><div class="form-group select-page-size-wrap"><select class="form-control" title="Rows on page" ng-model="itemsPerPage" ng-options="i for i in [5,10,15,20,25,50,100]" ng-change="pageChanged(currentPage, itemsPerPage, filter)"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/appointments/appointments.html','<div ba-panel=""><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"><button type="button" class="btn btn-primary" ng-click="appoint()">Adicionar Apontamento</button></div></div><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><div><div class="col-md-6"><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="updateAppointmentData()"><i class="fa fa-search"></i></span> <input type="text" name="AppSearch" id="appSearch" class="form-control" value="" placeholder="Buscar apontamento de produtor" ng-model="filter.search" ng-change="updateAppointmentData(filter)"></div></div></div><table class="table table-striped col-md-12" st-pipe="callServer" st-table="producersAppDisplay" st-safe-src="producersApp"><thead><tr class="sortable"><th st-sort="id" class="col-md-1">#</th><th st-sort="name" st-sort-default="true">Produtor</th><th st-sort="appointment">Apontamento</th><th st-sort="activity">Atividade</th><th st-sort="accomplished">Realizado</th><th st-sort="date">Data</th><th st-sort="nexAppointmentDate">Data da Proxima Visita</th><th>Descri\xE7\xE3o</th><th>Anexos</th><th st-sort="cost">Custo</th><th>A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in producersAppDisplay"><td>{{item.id}}</td><td>{{item.producer_name}}</td><td>{{item.appointment_title}}</td><td>{{item.activity_title}}</td><td>{{item.accomplished ? \'Realizado\' : \'N\xE3o Realizado\'}}</td><td>{{item.date | date:format: dd/MM/yyyy}}</td><td>{{item.nextAppointmentDate | date:format: dd/MM/yyyy}}</td><td>{{item.description}}</td><td><button type="button" class="btn btn-default" title="Anexos" ng-click="listAttachments(item.attachments, item.appointment_title)" ng-disabled="item.attachments.length == 0"><i class="fa fa-paperclip"></i></button></td><td>{{item.cost | number:2}}</td><td><button type="button" class="btn btn-default" title="Editar" ng-click="edit(item)"><i class="fa fa-edit"></i></button> <button type="button" class="btn btn-default" title="Excluir" ng-click="delete(item)"><i class="fa fa-trash"></i></button></td></tr><tr ng-if="producersApp.length == 0"><td colspan="10">Nenhum produtor recebeu apontamento</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="10" class="text-center"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></td></tr></tbody><tfoot><tr><td colspan="2"><ul uib-pagination="" total-items="totalAppItems" ng-model="currentAppPage" items-per-page="itemsPerPageApp" max-size="10" ng-change="pageChangedApp(currentAppPage, itemsPerPageApp, filterApp)" class="pagination-sm" boundary-link-numbers="true" rotate="false"></ul></td><td></td><td><div class="form-group select-page-size-wrap"><select class="form-control" title="Rows on page" ng-model="itemsPerPageApp" ng-options="i for i in [5,10,15,20,25,50,100]" ng-change="pageChangedApp(currentAppPage, itemsPerPageApp, filterApp)"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div ba-panel=""><div class="row"><br></div><div class="row"><br></div></div>');
$templateCache.put('app/pages/orders/orders.html','<div ba-panel=""><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"><button type="button" class="btn btn-primary" ng-click="newOrder()">Novo Pedido...</button></div></div><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><table class="table table-striped" st-table="orderDataDisplay" st-safe-src="orderData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="supplier">Fornecedor</th><th st-sort="reference">Refer\xEAncia</th><th st-sort="first_tag">N\xFAmero Inicial</th><th st-sort="tag_quantity">Quantidade</th><th st-sort="sent">Solicitado</th><th st-sort="received">Recebido</th><th></th></tr><tr></tr><tr><th></th><th><input st-search="supplier" placeholder="Pesquisar por Fornecedor" class="input-sm form-control search-input" type="search"></th><th><input st-search="reference" placeholder="Pesquisar por Refer\xEAncia" class="input-sm form-control search-input" type="search"></th><th><input st-search="first_tag" placeholder="Pesquisar por N\xFAmero Inicial" class="input-sm form-control search-input" type="search"></th><th><input st-search="tag_quantity" placeholder="Pesquisar por Quantidade" class="input-sm form-control search-input" type="search"></th><th colspan="3"></th></tr></thead><tbody><tr ng-repeat="item in orderDataDisplay"><td class="table-id">{{item.id}}</td><td>{{item.supplier}}</td><td>{{item.reference}}</td><td>{{item.first_tag}}</td><td>{{item.tag_quantity}}</td><td>{{(item.sent) ? \'Pedido Enviado\' : \'A enviar\'}}</td><td>{{(item.received) ? \'PedidoRecebido\' : \'A receber\'}}</td><td><button type="button" class="btn btn-default" title="Editar" ng-click="editOrder(item.id, \'edit\')" ng-disabled="item.received"><i class="fa fa-edit"></i></button> <button type="button" class="btn btn-default" title="Excluir" ng-click="editOrder(item.id, \'delete\')" ng-disabled="item.received"><i class="fa fa-trash"></i></button> <button type="button" class="btn btn-default" title="Confirmar Envio" ng-click="sendOrder(item.id)" ng-disabled="item.sent"><i class="fa fa-sign-out"></i></button> <button type="button" class="btn btn-default" title="Confirmar Recebimento" ng-click="receiveOrder(item.id)" ng-disabled="!item.sent || item.received"><i class="fa fa-sign-in"></i></button></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="orderDataSize" st-displayed-pages="5"></div></td><td colspan="4" class="text-center"><div class="form-group select-page-size-wrap"><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/producers/producers.html','<div ba-panel=""><div class="row"><br></div><div class="row"><div><div class="col-md-6 col-md-offset-3"><form class="form"><div class="form-group"><label>Nome do produtor</label> <input type="text" ng-model="producer.name" name="producer.name" class="form-control" id="name"> <input type="hidden" ng-model="producer.id" name="producer.id" class="form-control" id="id" value="{{producer.id}}"></div><div class="form-group"><input type="checkbox" id="hasScale" ng-model="producer.hasScale" name="producer.hasScale" class="form-check-input"> <label class="form-check-label" for="hasScale">Possui Escala?</label></div><div class="form-group"><input type="checkbox" id="inactive" ng-model="producer.inactive" name="producer.inactive" class="form-check-input"> <label class="form-check-label" for="inactive">Inativo</label></div><div class="form-group"><input type="checkbox" id="in_management_program" ng-model="producer.in_management_program" value="false" name="in_management_program" class="form-check-input"> <label class="form-check-label" for="in_management_program">Programa de gest\xE3o</label></div><button type="button" class="btn btn-primary pull-right" ng-click="save(producer)" id="save" ng-disabled="!producer.name">Salvar</button> <button type="reset" class="btn btn-secundary pull-right" style="margin-right:10px">Limpar</button></form></div></div></div></div><div ba-panel=""><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><div><div class="col-md-6"><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="updateData()"><i class="fa fa-search"></i></span> <input type="text" name="sarch" id="search" class="form-control" value="" placeholder="Busca produtor" ng-model="filter.search" ng-change="updateData(filter)"></div></div></div><table class="table table-striped col-md-12" st-pipe="callServer" st-table="producersDisplay" st-safe-src="producers"><thead><tr class="sortable"><th st-sort="id" class="col-md-1">#</th><th st-sort="name" st-sort-default="true" class="col-md-4">Produtor</th><th st-sort="active">status</th><th st-sort="in_management_program">Programa de Gest\xE3o</th><th st-sort="hasScale">Possui Escala?</th><th>a\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in producersDisplay"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{(item.inactive) ? "inativo" : "Ativo" }}</td><td>{{(item.in_management_program) ? "Sim " : "N\xE3o "}}</td><td>{{(item.hasScale) ? "Sim " : "N\xE3o "}}</td><td><button type="button" class="btn btn-default" title="Editar" ng-click="edit(item)"><i class="fa fa-edit"></i></button> <button type="button" class="btn btn-default" title="Excluir" ng-click="delete(item)"><i class="fa fa-trash"></i></button> <button type="button" class="btn btn-default" title="Apontar" ng-click="appoint(item)"><i class="fa fa-hand-o-right"></i></button></td></tr><tr ng-if="producers.length == 0"><td colspan="5">Nenhum produtor cadastrado</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></td></tr></tbody><tfoot><tr><td colspan="2"><ul uib-pagination="" total-items="totalItems" ng-model="currentPage" items-per-page="itemsPerPage" max-size="10" ng-change="pageChanged(currentPage, itemsPerPage, filter)" class="pagination-sm" boundary-link-numbers="true" rotate="false"></ul></td><td></td><td><div class="form-group select-page-size-wrap"><select class="form-control" title="Rows on page" ng-model="itemsPerPage" ng-options="i for i in [5,10,15,20,25,50,100]" ng-change="pageChanged(currentPage, itemsPerPage, filter)"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/tagLot/tagLot.html','<div ba-panel=""><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"><button type="button" class="btn btn-primary" ng-click="newTagLot()">Novo Lote...</button></div></div><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><table class="table table-striped" st-pipe="callServer" st-table="tagLotDataDisplay" st-safe-src="tagLotData"><thead><tr><td><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="filterByFarmName(farmName)"><i class="fa fa-search"></i></span> <input type="text" name="farmNameSearch" id="farmNameSearch" class="form-control" value="" placeholder="Busca por fazenda" ng-model="farmName" ng-model-options="{ debounce: 1000 }" ng-change="filterByFarmName(farmName)"></div></td></tr><tr class="sortable"><th st-sort="farm_name">Fazenda</th><th st-sort="sequence_name">Sequencia</th><th st-sort="first_tag_number">Brinco Inicial</th><th st-sort="last_tag">Brinco Final</th><th st-sort="status">Situa\xE7\xE3o</th><th st-sort="delivered_on" st-sort-default="reverse">Retirado em</th><th st-sort="used_count">Brincos Usados</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in tagLotDataDisplay"><td>{{item.farm_name}}</td><td>{{item.sequence_name}}</td><td>{{item.first_tag_number}}</td><td>{{item.last_tag}}</td><td>{{item.status_description}} <span ng-if="item.delivered">para {{item.delivered_to}}</span></td><td>{{item.delivered_on | date:"dd/MM/yyyy"}}</td><td ng-class="{\'bg-danger\':(!item.delivered && item.used_count > 0)}"><a ng-show="(!item.delivered && item.used_count > 0)" class="fa fa-exclamation-triangle" data-toggle="tooltip" title="Brincos usados mas sem registro de entrega para produtor."></a> <span>{{item.used_count}} de {{item.tag_quantity}}</span></td><td><button type="button" class="btn btn-default" title="Entregar ao Produtor" ng-click="deliverLot(item.id)" ng-disabled="item.delivered"><i class="fa fa-share"></i></button> <button type="button" class="btn btn-default" title="Gerar Excel" ng-click="excelLot(item.id, item.used_count)" ng-disabled="!item.delivered"><i class="fa fa-file-excel-o"></i></button> <button type="button" class="btn btn-default" title="Gerar Recibo Financeiro" ng-click="excelLotReceipt(item.id)" ng-disabled="!item.delivered"><i class="fa fa-money"></i></button> <button type="button" class="btn btn-default" title="Estornar Entrega" ng-click="cancelDeliverLot(item.id)" ng-disabled="!item.delivered"><i class="fa fa-undo"></i></button> <button type="button" class="btn btn-default" title="Excluir" ng-click="deleteLot(item.id)" ng-disabled="item.delivered"><i class="fa fa-trash"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><ul uib-pagination="" total-items="totalItems" ng-model="currentPage" items-per-page="itemsPerPage" max-size="10" ng-change="pageChanged(currentPage, itemsPerPage, farmName)" class="pagination-sm" boundary-link-numbers="true" rotate="false"></ul></td><td colspan="3" class="text-center"><div class="form-group select-page-size-wrap"><select class="form-control" title="Rows on page" ng-model="itemsPerPage" ng-change="pageChanged(currentPage, itemsPerPage, farmName)" ng-options="i for i in [5,10,15,20,25,50,100]"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/tags/tags.html','<div ba-panel=""><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><table class="table table-striped" st-pipe="callServer" st-table="tagDataDisplay" st-safe-src="tagData"><thead><tr><td><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="filterByTagNumber(tagNumber)"><i class="fa fa-search"></i></span> <input type="text" name="tagNumberSearch" id="tagNumberSearch" class="form-control" value="" placeholder="Busca por n\xFAmero do brinco, fazenda ou sequ\xEAncia" ng-model="tagNumber" ng-change="filterByTagNumber(tagNumber)"></div></td></tr><tr class="sortable"><th st-sort="tag_number" st-sort-default="true">N\xFAmero</th><th>Fazenda</th><th>Sequencia</th><th>Situa\xE7\xE3o</th><th>Usado</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in tagDataDisplay"><td>{{item.tag_number}}</td><td>{{item.farm_name}}</td><td>{{item.sequence_name}}</td><td>{{item.tag_status_description}}</td><td>{{item.used ? \'Sim\' : \'N\xE3o\'}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></td></tr></tbody><tfoot><tr><td colspan="2"><ul uib-pagination="" total-items="totalItems" ng-model="currentPage" items-per-page="itemsPerPage" max-size="10" ng-change="pageChanged(currentPage, itemsPerPage)" class="pagination-sm" boundary-link-numbers="true" rotate="false"></ul></td><td></td><td><div class="form-group select-page-size-wrap"><select class="form-control" title="Rows on page" ng-model="itemsPerPage" ng-options="i for i in [5,10,15,20,25,50,100]" ng-change="pageChanged(currentPage, itemsPerPage)"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/config/activities/activities.html','<div ba-panel=""><div class="row"><br></div><div class="row"><div class="col-md-6 col-md-offset-3"><form class="form"><div class="row"><div class="form-group"><label for="farm">Projeto*</label><ui-select name="farm" ng-model="appointmentsList.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="test()" required=""><ui-select-match placeholder="Selecione o Apontamento">{{$select.selected.title}}</ui-select-match><ui-select-choices repeat="item.id as item in appointmentsList.data | filter: $select.search"><span ng-bind-html="item.title | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group input-md" required="required"><label>Atividade</label> <input type="hidden" ng-model="activity.id" name="activity.id" class="form-control"> <input type="text" ng-model="appointmentsList.apo_act" name="activity.title" class="form-control"></div><button type="button" class="btn btn-primary pull-right" ng-click="save()" ng-disabled="!appointmentsList.apo_act">Salvar</button> <button type="reset" class="btn btn-secundary pull-right" ng-click="reset()" style="margin-right:10px">Limpar</button></div></form></div></div></div><div ba-panel=""><div class="row"><div><table class="table table-striped" st-pipe="callServer" st-table="activitiesDataDisplay" st-safe-src="activitiesData"><thead><tr><td><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="filterByTitler(searchTitle)"><i class="fa fa-search"></i></span> <input type="text" name="titleSearch" id="titleSearch" class="form-control" value="" placeholder="Busca por nome da atividade" ng-model="searchTitle" ng-change="filterByTitle(searchTitle)"></div></td></tr><tr class="sortable"><th>Projeto</th><th st-sort="tag_number" st-sort-default="true">Atividades</th><th>Apagar</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in activitiesDataDisplay"><td>{{ (appointmentsList.data | filter : { \'id\': item.appointment})[0].title }}</td><td>{{item.title}}</td><td><button type="button" class="btn btn-default" title="Editar" ng-click="edit(item)"><i class="fa fa-edit"></i></button> <button type="button" class="btn btn-default" title="Excluir" ng-click="delete(item)"><i class="fa fa-trash"></i></button></td></tr><tr ng-if="activitiesData.length == 0"><td colspan="3">N\xE3o h\xE1 atividades</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></td></tr></tbody><tfoot><tr><td colspan="2"><ul uib-pagination="" total-items="totalItems" ng-model="currentPage" items-per-page="itemsPerPage" max-size="10" ng-change="pageChanged(currentPage, itemsPerPage)" class="pagination-sm" boundary-link-numbers="true" rotate="false"></ul></td><td><div class="form-group select-page-size-wrap"><select class="form-control" title="Rows on page" ng-model="itemsPerPage" ng-options="i for i in [5,10,15,20,25,50,100]" ng-change="pageChanged(currentPage, itemsPerPage)"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/config/appointments/appointments.html','<div ba-panel=""><div class="row"><br></div><div class="row"><div><div class="col-md-6 col-md-offset-3"><form class="form"><div class="form-group"><label>Nome do Projeto</label> <input type="text" ng-model="appointment.title" name="appointment.title" class="form-control"> <input type="hidden" ng-model="appointment.id" name="appointment.id" class="form-control"></div><button type="button" class="btn btn-primary pull-right" ng-click="newAppointment(appointment)" ng-disabled="!appointment.title || (!appointment.title && !appointment.id)">Salvar</button> <button type="reset" class="btn btn-secundary pull-right" ng-click="reset()" style="margin-right:10px">Limpar</button></form></div></div></div></div><div ba-panel=""><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><div><div class="col-md-6"><div class="input-group"><span class="input-group-addon addon-left input-group-addon" ng-click="updateData()"><i class="fa fa-search"></i></span> <input type="text" name="sarch" id="search" class="form-control" value="" placeholder="Busca projeto" ng-model="filter.search" ng-change="updateData(filter)"></div></div></div><table class="table table-striped" st-pipe="callServer" st-table="appointmentsDisplay" st-safe-src="appointments"><thead><tr class="sortable"><th st-sort="name" st-sort-default="true" class="col-md-6">Titulo</th><th class="col-md-6">Op\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in appointmentsDisplay"><td>{{item.title}}</td><td><button type="button" class="btn btn-default" title="Editar" ng-click="edit(item)"><i class="fa fa-edit"></i></button> <button class="btn btn-default" title="Excluir" ng-click="deleteAppointment(item)"><i class="fa fa-trash"></i></button></td></tr><tr ng-if="appointments.length == 0"><td colspan="5">N\xE3o h\xE1 projetos</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></td></tr></tbody><tfoot><tr><td colspan="2"><ul uib-pagination="" total-items="totalItems" ng-model="currentPage" items-per-page="itemsPerPage" max-size="10" ng-change="pageChanged(currentPage, itemsPerPage, filter)" class="pagination-sm" boundary-link-numbers="true" rotate="false"></ul></td><td></td><td><div class="form-group select-page-size-wrap"><select class="form-control" title="Rows on page" ng-model="itemsPerPage" ng-options="i for i in [5,10,15,20,25,50,100]" ng-change="pageChanged(currentPage, itemsPerPage, filter)"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/config/sequence/sequence.html','<div ba-panel=""><div class="row"><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"><button type="button" class="btn btn-primary" ng-click="newSequence()">Nova Sequ\xEAncia...</button></div></div><div class="row"><br></div><div class="row"><div class="horizontal-scroll"><table class="table table-striped" st-table="sequenceDataDisplay" st-safe-src="sequenceData"><thead><tr class="sortable"><th st-sort="name">Nome</th><th st-sort="first_number">N\xFAmero Inicial</th><th st-sort="prefixo">Prefixo</th><th st-sort="last_number">\xDAltimo N\xFAmero</th><th st-sort="sufixo">Sufixo</th><th></th></tr><tr></tr><tr><th><input st-search="name" placeholder="Pesquisar por Nome" class="input-sm form-control search-input" type="search"></th><th><input st-search="first_number" placeholder="Pesquisar por N\xFAmero Inicial" class="input-sm form-control search-input" type="search"></th><th><input st-search="prefixo" placeholder="Pesquisar por Prefixo" class="input-sm form-control search-input" type="search"></th><th><input st-search="last_number" placeholder="Pesquisar por \xDAltimo N\xFAmero" class="input-sm form-control search-input" type="search"></th><th><input st-search="sufixo" placeholder="Pesquisar por Sufixo" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="item in sequenceDataDisplay"><td>{{item.name}}</td><td>{{item.first_number}}</td><td>{{item.prefixo}}</td><td><span title="Faltam {{item.last_number - item.last_tag_emitted}} brincos">{{zpad(item.last_tag_emitted, item.last_number)}} de {{item.last_number}}</span></td><td>{{item.sufixo}}</td><td><button type="button" class="btn btn-default" title="Editar" ng-click="editSequence(item.id, \'edit\')"><i class="fa fa-edit"></i></button> <button type="button" class="btn btn-default" title="Excluir" ng-click="editSequence(item.id, \'delete\')"><i class="fa fa-trash"></i></button></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="sequenceDataSize" st-displayed-pages="5"></div></td><td colspan="3" class="text-center"><div class="form-group select-page-size-wrap"><select class="form-control selectpicker show-tick" title="Linhas na p\xE1gina" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/orders/orderModal/orderModal.html','<div class="modal-content"><form><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Manuten\xE7\xE3o de Pedidos de Brincos</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="orderReference">Refer\xEAncia do pedido</label> <input type="text" name="orderReference" id="orderReference" class="form-control" value="" required="required" placeholder="Refer\xEAncia do Pedido" ng-model="order.reference"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="orderSupplier">Fornecedor</label> <input type="text" name="orderSupplier" id="orderSupplier" class="form-control" value="" required="required" placeholder="Fornecedor" ng-model="order.supplier"></div></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group"><label for="sequence">Sequencia</label><ui-select name="sequence" ng-model="order.sequence" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="sequenceChanged($item, $model)"><ui-select-match placeholder="Sequencia de Brincos">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="sequence.id as sequence in sequenceData | filter: $select.search"><span ng-bind-html="sequence.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group"><label for="initialNumber">Brinco Inicial</label> <input type="number" class="form-control" name="initialNumber" id="initialNumber" ng-model="order.first_tag" placeholder="Brinco Inicial" readonly=""></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group"><label for="tagQuantity">Quantidade</label> <input type="number" class="form-control" name="tagQuantity" id="tagQuantity" ng-model="order.tag_quantity" placeholder="Quantidade de Brincos"></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-click="saveOrder()">SALVAR</button> <button type="button" class="btn btn-cancel" ng-click="$dismiss()">FECHAR</button></div></form></div>');
$templateCache.put('app/pages/producers/attachmentsModal/attachmentsModal.html','<div class="modal-content"><form><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{title}}</h4></div><div class="modal-body" ng-show="!loading"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table class="table col-md-12"><thead><tr><th>Anexos</th></tr></thead><tbody><tr ng-repeat="att in attachments"><td><a href="https://s3.amazonaws.com/cooperativas-upload/{{att.attachment}}" target="_blank">{{att.filename}}</a></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-if="!loading"><button type="button" class="btn btn-cancel" ng-click="$dismiss()">FECHAR</button></div></form></div>');
$templateCache.put('app/pages/producers/producersModal/producersModal.html','<div class="modal-content"><form><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" ng-if="producerData && itemEdit == null || !producerData && itemEdit == null">Apontar Produtores</h4><h4 class="modal-title" ng-if="producerData && itemEdit != null">Editar Apontamento</h4></div><div class="modal-body" ng-show="!loading"><div ng-if="producerData" class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="producer">Produtor*</label><ui-select name="producer" ng-model="prodAppointment.producer_id" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" required=""><ui-select-match placeholder="Selecione o Produtor">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="producer.id as producer in producerData | filter: $select.search"><span ng-bind-html="producer.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="farm">Tipo de Apontamento*</label><ui-select name="farm" ng-model="prodAppointment.appointment_id" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="appointmentSelect()" required=""><ui-select-match placeholder="Selecione o Apontamento">{{$select.selected.title}}</ui-select-match><ui-select-choices repeat="appointment.id as appointment in appointmentData | filter: $select.search"><span ng-bind-html="appointment.title | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="activity">Atividade*</label><ui-select name="activity" ng-model="prodAppointment.activity_id" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="activitySelect()" required=""><ui-select-match placeholder="Selecione Atividade">{{$select.selected.title}}</ui-select-match><ui-select-choices repeat="activity.id as activity in activityData | filter: {\'appointment\': prodAppointment.appointment_id}"><span ng-bind-html="activity.title | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="date">Data*</label> <input type="date" class="form-control" value="{{prodAppointment.date}}" name="date" id="date" ng-model="prodAppointment.date" required=""></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><div class="form-check"><input class="form-check-input" type="checkbox" name="check1" id="check1" ng-model="prodAppointment.accomplished"> <label class="form-check-label" for="check1">Realizado</label></div></div></div></div><br><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="description">Descri\xE7\xE3o*</label> <input type="text" class="form-control" name="description" id="description" ng-model="prodAppointment.description" placeholder="Descri\xE7\xE3o" required=""> <input type="hidden" class="form-control" name="producer_id" id="producer_id" ng-model="prodAppointment.producer_id" value="prodAppointment.producer_id"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="cost">Custo</label><div class="input-group"><span class="input-group-addon addon-left input-group-addon"><i class="fa fa-usd"></i></span> <input type="number" step="0.1" min="0" class="form-control" name="cost" id="cost" ng-model="prodAppointment.cost" placeholder="Custo"></div></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="date">Data da Proxima Visita</label> <input type="date" class="form-control" value="{{prodAppointment.nextAppointmentDate}}" name="nextAppointmentDate" id="nextAppointmentDate" ng-model="prodAppointment.nextAppointmentDate"></div></div></div><br><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label class="import-file" for="anexo">Adicionar anexo</label> <input type="file" files-input="" class="form-control" name="anexo" id="anexo" ng-model="currentAttachment" ng-change="addAttachment()"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-if="itemEdit && (itemEdit.attachments.length > 0)"><table class="table col-md-12"><thead><tr><th>Anexos</th></tr></thead><tbody><tr ng-repeat="att in itemEdit.attachments"><td><a href="https://s3.amazonaws.com/cooperativas-upload/{{att.attachment}}" target="_blank">{{att.filename}}</a> <button ng-click="removeAttachment(att)" type="button" class="btn btn-default pull-right"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div></div><div class="row" ng-show="attachments && attachments.length > 0"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><table class="table col-md-12"><thead><tr><th>Novos anexos</th></tr></thead><tbody><tr ng-repeat="newAtt in attachments"><td>{{newAtt[0].name | limitTo: 45 }} {{ newAtt[0].name.length > 45 ? \'...\' : \'\'}}<button ng-click="removeFile(newAtt)" type="button" class="btn btn-default pull-right"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div></div></div><div class="modal-body" ng-if="loading"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div><div class="modal-footer" ng-if="!loading"><button ng-if="itemEdit == null" type="submit" class="btn btn-primary" ng-disabled="(!prodAppointment.description || !prodAppointment.appointment_id || !prodAppointment.date || !prodAppointment.activity_id || !prodAppointment.producer_id)" ng-click="save()">SALVAR</button> <button ng-if="producerData && itemEdit != null" type="submit" class="btn btn-primary" ng-disabled="(!prodAppointment.description || !prodAppointment.appointment_id || !prodAppointment.date || !prodAppointment.activity_id || !prodAppointment.producer_id)" ng-click="edit()">EDITAR</button> <button type="button" class="btn btn-cancel" ng-click="$dismiss()">FECHAR</button></div></form></div>');
$templateCache.put('app/pages/tagLot/tagLotModal/tagLotModal.html','<div class="modal-content"><form><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Lote de Brincos</h4></div><div class="modal-body"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="farm">Fazenda</label><ui-select name="farm" ng-model="tagLotConfig.farm_id" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Selecione a Fazenda">{{$select.selected.id}} - {{$select.selected.name}}</ui-select-match><ui-select-choices repeat="farm.id as farm in farmData | filter: $select.search"><span ng-bind-html="farm.id + \' - \' + farm.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="sequence">Sequencia</label><ui-select name="sequence" ng-model="tagLotConfig.sequence" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="sequenceChanged($item, $model)"><ui-select-match placeholder="Selecione a Sequencia de Brincos">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="sequence.id as sequence in sequenceData | filter: $select.search"><span ng-bind-html="sequence.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="initialNumber">Brinco Inicial</label> <input type="text" class="form-control" name="initialNumber" id="initialNumber" ng-model="tagLotConfig.first_tag" placeholder="Brinco Inicial" readonly=""></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="tagQuantity">Quantidade</label> <input type="number" class="form-control" name="tagQuantity" id="tagQuantity" ng-model="tagLotConfig.tag_quantity" placeholder="Quantidade de Brincos"></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-click="saveTagLotConfig()">SALVAR</button> <button type="button" class="btn btn-cancel" ng-click="$dismiss()">FECHAR</button></div></form></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>JetBov</span>Cooperativas</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><i class="fa fa-tree fa-3x" aria-hidden="true"></i></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="" class="signout" ng-click="signOut()"><i class="fa fa-power-off"></i>Sair</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue" ng-change="ngChange"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">{{textOn || \'ON\'}}</span> <span class="handle"></span> <span class="handle handle-off">{{textOff || \'OFF\'}}</span></div></div></label>');
$templateCache.put('app/pages/config/sequence/sequenceModal/sequenceModal.html','<div class="modal-content"><form><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Configura\xE7\xE3o de Sequencia de Numera\xE7\xE3o de Brincos</h4></div><div class="modal-body"><div class="row"><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="sequenceName">Nome</label> <input type="text" class="form-control" id="sequenceName" ng-model="sequence.name" placeholder="Nome da sequencia"></div></div></div><div class="row"><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group"><label for="prefixo">Prefixo</label> <input type="text" class="form-control" id="prefixo" ng-model="sequence.prefixo" placeholder="Prefixo"></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group"><label for="initialNumber">No. Inicial</label> <input type="number" class="form-control" id="initialNumber" ng-model="sequence.first_number" placeholder="N\xFAmero Inicial"></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group"><label for="lastNumber">No. Final</label> <input type="number" class="form-control" id="lastNumber" ng-model="sequence.last_number" placeholder="N\xFAmero Final"></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="form-group"><label for="sufixo">Sufixo</label> <input type="text" class="form-control" id="sufixo" ng-model="sequence.sufixo" placeholder="Sufixo"></div></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="panel"><div class="panel-heading"><h2 class="panel-title">\xDAltimo Brinco Emitido</h2></div><div class="panel-body text-center"><h1 ng-if="editing && (sequence.last_tag_emitted > sequence.first_number)">{{sequence.prefixo}}{{sequence.last_tag_emitted}}{{sequence.sufixo}}</h1><h1 ng-if="!editing">Nenhum brinco gerado</h1></div></div></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-click="saveSequence()">SALVAR</button> <button type="button" class="btn btn-cancel" ng-click="$dismiss()">FECHAR</button></div></form></div>');}]);